export const selectDashboardEplTchData = (state) => state.dashboard?.eplTchData;
export const selectDashboardDayWiseData = (state) => state.dashboard?.dayWiseData || {};
export const selectDashboardLoading = (state) => Boolean(state.dashboard?.loading);
export const selectDashboardDayWiseLoading = (state) => Boolean(state.dashboard?.dayWiseLoading);
export const selectDashboardError = (state) => state.dashboard?.error;
export const selectDashboardFromCache = (state) => Boolean(state.dashboard?.fromCache);
export const selectDashboardLastFetchedAt = (state) => state.dashboard?.lastFetchedAt;
export const selectDashboardActiveCacheKey = (state) => state.dashboard?.activeCacheKey;
